import { MEDIAFOLDEREXPLORER_RECIVE } from '../../Rutab/RutabConstants';

const defaultState = {
    mediaFolders: [],
};

const AddOrReplaceMediaFolder = (folders, payload) => {
    var i = folders.findIndex((folder) => folder.blockSystemId === payload.blockSystemId);

    if(i > -1){
        folders[i] = payload
        return folders;
    }        

    return [...folders, payload]
}

export const mediaFolderExplorer = (state = defaultState, action) => {
    switch (action.type) {
        case MEDIAFOLDEREXPLORER_RECIVE:
            return {
                ...state,    
                mediaFolders: AddOrReplaceMediaFolder(state.mediaFolders, action.payload),            
            };
        default:
            return state;
    }
};